document.addEventListener("DOMContentLoaded", () => {
  // 针对每个 section 初始化轮播
  document.querySelectorAll('.kickstarter-switch').forEach((section, index) => {
    // IntersectionObserver 控制初始化
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          let parentEl = entry.target;

          // Init Tabs Event
          let tabBox = parentEl.querySelector('.tab-box');
          $(tabBox).off('click', 'button').on('click', 'button', function() {
            let tabId = $(this).data('tab');
            // 切换按钮样式
            $(this).siblings().removeClass('active');
            $(this).addClass('active');
            // 切换内容
            $(parentEl).find('.tab-panel').removeClass('active');
            $(`#${tabId}`).addClass('active');
          });

          // observer.unobserve(parentEl); // 只执行一次
        }
      });
    }, { threshold: 0.3 });

    observer.observe(section);
  });
});
